const BROADCAST_DEVICES_KEY = 'broadcast_selected_devices';
const BROADCAST_NAME_KEY = 'broadcast_name';
const BROADCAST_STREAM_ID_KEY = 'broadcast_stream_id';
const BROADCAST_STATE_KEY = 'broadcast_state'; //   NEW
const BROADCAST_START_TIME_KEY = 'broadcast_start_time'; //   NEW

export const BroadcastStorage = {
  // Store selected devices when broadcast starts
  storeSelectedDevices(deviceSerials: string[]): void {
    try {
      localStorage.setItem(BROADCAST_DEVICES_KEY, JSON.stringify(deviceSerials));
    } catch (error) {
      console.error('Failed to store broadcast devices:', error);
    }
  },

  // Get stored devices for stopping broadcast
  getSelectedDevices(): string[] {
    try {
      const stored = localStorage.getItem(BROADCAST_DEVICES_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Failed to retrieve broadcast devices:', error);
      return [];
    }
  },

  // Store broadcast name
  storeBroadcastName(name: string): void {
    try {
      localStorage.setItem(BROADCAST_NAME_KEY, name);
    } catch (error) {
      console.error('Failed to store broadcast name:', error);
    }
  },

  // Get stored broadcast name
  getBroadcastName(): string {
    try {
      return localStorage.getItem(BROADCAST_NAME_KEY) || '';
    } catch (error) {
      console.error('Failed to retrieve broadcast name:', error);
      return 'Live Broadcast';
    }
  },

  // Store stream ID from broadcast response
  storeStreamId(streamId: number): void {
    try {
      localStorage.setItem(BROADCAST_STREAM_ID_KEY, streamId.toString());
    } catch (error) {
      console.error('Failed to store stream ID:', error);
    }
  },

  // Get stored stream ID
  getStreamId(): number | null {
    try {
      const stored = localStorage.getItem(BROADCAST_STREAM_ID_KEY);
      return stored ? parseInt(stored, 10) : null;
    } catch (error) {
      console.error('Failed to retrieve stream ID:', error);
      return null;
    }
  },

  //   NEW: Store broadcast state
  storeBroadcastState(state: 'stopped' | 'live' | 'paused'): void {
    try {
      localStorage.setItem(BROADCAST_STATE_KEY, state);
      if (state === 'live') {
        // Store start time when going live
        localStorage.setItem(BROADCAST_START_TIME_KEY, Date.now().toString());
      }
    } catch (error) {
      console.error('Failed to store broadcast state:', error);
    }
  },

  //   NEW: Get stored broadcast state
  getBroadcastState(): 'stopped' | 'live' | 'paused' {
    try {
      const stored = localStorage.getItem(BROADCAST_STATE_KEY);
      return (stored as 'stopped' | 'live' | 'paused') || 'stopped';
    } catch (error) {
      console.error('Failed to retrieve broadcast state:', error);
      return 'stopped';
    }
  },

  //   NEW: Store broadcast start time
  storeBroadcastStartTime(timestamp: number): void {
    try {
      localStorage.setItem(BROADCAST_START_TIME_KEY, timestamp.toString());
    } catch (error) {
      console.error('Failed to store broadcast start time:', error);
    }
  },

  //   NEW: Get stored broadcast start time
  getBroadcastStartTime(): number | null {
    try {
      const stored = localStorage.getItem(BROADCAST_START_TIME_KEY);
      return stored ? parseInt(stored, 10) : null;
    } catch (error) {
      console.error('Failed to retrieve broadcast start time:', error);
      return null;
    }
  },

  //   NEW: Check if broadcast is active
  isBroadcastActive(): boolean {
    const state = this.getBroadcastState();
    const hasDevices = this.hasStoredDevices();
    const hasStreamId = this.getStreamId() !== null;
    
    return (state === 'live' || state === 'paused') && hasDevices && hasStreamId;
  },

  // Clear stored devices when broadcast ends
  clearSelectedDevices(): void {
    try {
      localStorage.removeItem(BROADCAST_DEVICES_KEY);
      localStorage.removeItem(BROADCAST_NAME_KEY);
      localStorage.removeItem(BROADCAST_STREAM_ID_KEY);
      localStorage.removeItem(BROADCAST_STATE_KEY); //   Clear state
      localStorage.removeItem(BROADCAST_START_TIME_KEY); //   Clear start time
    } catch (error) {
      console.error('Failed to clear broadcast devices:', error);
    }
  },

  // Check if we have stored devices
  hasStoredDevices(): boolean {
    return this.getSelectedDevices().length > 0;
  }
};